import { styled } from '@mui/material';
import Box from '@/components/Box';
import MarchingBlocks from './MarchingBlocks';

const Message = styled(Box)({
  position: 'absolute',
  top: '66%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '1.8rem',
  textAlign: 'center',
  width: '100%',
  maxWidth: '500px',
  margin: '40px auto',
  padding: '0.3rem 0.7rem',
});

const AppLoading = ({ reason, messages, style = {} }) => (
  <>
    <MarchingBlocks
      data-reason={reason}
      style={{
        display: 'block',
        margin: 'auto',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        ...style,
      }}
    />
    {messages && (
      <Message component="div">
        {Array.isArray(messages)
          ? messages.map((m, i) => <div key={i}>{m}</div>)
          : messages}
      </Message>
    )}
  </>
);

export default AppLoading;
